import { CASHBACK_WEB, LINK_SECRET } from '../../config'


const SEPARATOR = String.fromCharCode(31)
const CHECKSUM_LENGTH = 7

const fnv1a = (input) => {
	let hash = 0x811c9dc5
	for (let i = 0; i < input.length; i++) {
		hash ^= input.charCodeAt(i)
		hash = Math.imul(hash, 0x01000193) >>> 0
	}
	return hash >>> 0
}

const checksumOf = (name) => {
	const hash = fnv1a(`${LINK_SECRET}${SEPARATOR}${name.trim().toLowerCase()}`)
	return hash.toString(36).padStart(CHECKSUM_LENGTH, '0')
}

const maskBytes = (bytes) => {
	const key = new TextEncoder().encode(LINK_SECRET)
	const out = new Uint8Array(bytes.length)
	for (let i = 0; i < bytes.length; i++) {
		out[i] = bytes[i] ^ key[i % key.length] ^ ((i * 0x5f + 0x2b) & 0xff)
	}
	return out
}

export const encodeBranchSlug = (name) => {
	const trimmed = String(name || '').trim()
	const payload = `${trimmed}${SEPARATOR}${checksumOf(trimmed)}`
	const masked = maskBytes(new TextEncoder().encode(payload))

	let binary = ''
	for (const byte of masked) binary += String.fromCharCode(byte)

	return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export const branchLink = (name) => {
	const origin = CASHBACK_WEB.replace(/\/+$/, '')
	return `${origin}/${encodeBranchSlug(name)}`
}
